import { environment } from "../../../environments/environment";
import { FETCH_METHODS, SearchConfig } from "./api.model";
import { DataTableSchema, DefaultTableSchema, TableColumnSchema } from "./dynamic-data-table.model";
import { SpinIdNumber, defaultSearchContainerButtons, CalendarYearDropdown, FiscalYearDropdown, MonthDropdown, PeriodDropdown, DealerNumberDropdown, AttendanceDropdown, DeliveryDropdown, AreaMutipleSelect, CourseNameCodeDropdown } from "./form-fields.model";
import { ButtonFieldConfig, DynamicFormArray, FormFieldConfig, Props } from "./form.model";

export const DealerTrainingBillingBaseUrl = () => {
    return environment['dealerTrainingBilling'] ?? 'dealerTrainingBilling';
};

const FormFieldArray: FormFieldConfig[] = structuredClone([SpinIdNumber, CalendarYearDropdown, FiscalYearDropdown, {...structuredClone(MonthDropdown),showSelect:true}, PeriodDropdown,
    DealerNumberDropdown, CourseNameCodeDropdown, AreaMutipleSelect, AttendanceDropdown, DeliveryDropdown])
const FormButtonArray: ButtonFieldConfig[] = structuredClone(defaultSearchContainerButtons);



export const DealerTrainingBillingSearchConfig: SearchConfig = {
    method: FETCH_METHODS['Post'],
    path: 'billingReportSearch',
    body:
    {
        "spinId": "",
        "calendarYear": "",
        "fiscalYear": "",
        "month": "",
        "period": "",
        "dealerNumber": "",
        "courseShortName": "",
        "area": [],
        "attendance": "",
        "delivery": ""
    }
}
const columnSchema:TableColumnSchema[] = [
        { label: 'Spin ID', fieldKey: 'spinid', sticky: true },
        { label: 'Dealer', fieldKey: 'organisation', sticky: true },
        { label: 'Course', fieldKey: 'title', isNotCamelCase: true },
        { label: 'Start Date', fieldKey: 'start_date' },
        { label: 'Completion Date', fieldKey: 'completion_date' },
        { label: 'Name', fieldKey: 'name' },
        { label: 'Status', fieldKey: 'status' },
        { label: 'location ID', fieldKey: 'class_no' },
        { label: 'Facility', fieldKey: 'facility' },
        { label: 'Amount($)', fieldKey: 'amount' },
    ];

export const DealerTrainingBillingExportSearchConfig: SearchConfig = {
    method: FETCH_METHODS['Post'],
    path: 'getSignedUrl',
    body: {
        bucketName: '',
        key: '',
        type: 'Download'
    }
};
export const DealerTrainingBillingReportTableSchema: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    columnSchema: columnSchema,
    serverSidePaginatation:true,
    exportConfig: {
        fileName: 'Course_Billing',
        exportMessage: "Course Billing Data",
        isCamelCase:['name'],
         schema:{
            spinid: "SPIN ID",
            organisation: "DEALER",
            title: "COURSE",
            start_date: "START DATE",
            completion_date: "COMPLETION DATE",
            name: "NAME",
            status: "STATUS",
            class_no: "LOCATION ID",
            facility: "FACILITY",
            amount: "AMOUNT($)",
        }
    }
}

export const DealerTrainingBillingReportFormArray: DynamicFormArray = {
    FieldsArray: FormFieldArray,
    ButtonsArray: FormButtonArray,
    searchConfig: DealerTrainingBillingSearchConfig,
}

export const DealerTrainingBillingReportProps: Props = {
    isSearchVisible: true,
    isTabStretch: true
}